module.exports = __webpack_public_path__ + "static/media/4 Train-Lateral_Z1.2c1839de.png";